// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__k-afu","spinner":"Spinner_spinner__Z6H3Z"};